import { create, filter, findAll, findOne, getOne, resetSave, update, simplePost } from "@/store/Crud/functions/actions";
// TODO code duplication
export const setLoading = async (store, loading) => {
    store.commit("IS_LOADING", loading);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    setLoading,
    simplePost,
};
